import { PatientChatEngine } from './PatientChatEngine';
import { demoDataSource } from '../../services/chat/demoDataSource';

export function PatientChat() {
  return <PatientChatEngine dataSource={demoDataSource} />;
}
